export { AvatarEditorModal } from './avatar-editor-modal';
